// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"dd9e0434","423":"fd2db067","453":"f92e4f05","479":"8890cdbe","529":"8585a7c2","619":"d0ab6d5c","628":"105e8f55","636":"d23f7a00","725":"0349acbd","739":"33ecce06","816":"8e0a538f","860":"847f526b","908":"d145d007","974":"9bb2dde9"}[chunkId] + ".chunk.js";
};